const JurisConfirmModal = ({ open, matterId, fields = [], onConfirm, onCancel, currentUnavailable = false }) => {
  if (!open) return null;
  const isAdd = f => f.action === 'add';
  const addedCount = fields.filter(f => f.changed && isAdd(f)).length;
  const updatedCount = fields.filter(f => f.changed && !isAdd(f)).length;
  return (
    <div className="popup-overlay" style={{ zIndex: 2000000 }} onClick={onCancel}>
      <div className="popup-modal" onClick={e => e.stopPropagation()}
           style={{ borderColor: '#d97706', maxWidth: 680, width: '92%' }}>
        <div className="popup-header" style={{ background: '#d97706' }}>
          <span className="popup-icon">⚠️</span>
          <span className="popup-title">Dossier déjà présent dans JurisÉvolution</span>
        </div>
        <div className="popup-content" style={{ background: '#fffdf7' }}>
          <p style={{ marginTop: 0 }}>
            Ce dossier existe déjà dans JurisÉvolution{matterId ? ` (ID ${matterId})` : ''}.
            Les coordonnées (<strong>adresse, téléphone, courriel</strong>) sont&nbsp;
            <span style={{ background: '#bbf7d0', padding: '0 4px' }}>ajoutées</span> sans
            supprimer les anciennes. Les autres champs (type, description, requérant,
            succursale) sont <span style={{ background: '#fde68a', padding: '0 4px' }}>mis à jour</span>.
          </p>
          {!currentUnavailable && (
            <p data-testid="juris-confirm-counts" style={{ marginTop: -6, fontSize: 13, color: '#6b7280' }}>
              {updatedCount > 0 ? `${updatedCount} champ${updatedCount > 1 ? 's' : ''} mis à jour` : 'Aucune mise à jour'}
              {' · '}
              {addedCount > 0 ? `${addedCount} ajout${addedCount > 1 ? 's' : ''}` : 'aucun ajout'}
            </p>
          )}
          {currentUnavailable ? (
            <div data-testid="juris-confirm-unavailable"
                 style={{ background: '#fee2e2', border: '1px solid #dc2626', borderRadius: 6,
                          padding: '10px 12px', color: '#991b1b' }}>
              Impossible de lire les valeurs actuelles dans JurisÉvolution pour le moment.
              La comparaison n'est pas disponible. Si vous confirmez, les nouvelles valeurs
              seront tout de même envoyées (mise à jour des champs + ajout des coordonnées).
            </div>
          ) : (
          <div style={{ maxHeight: 340, overflow: 'auto', border: '1px solid #e5d9b6', borderRadius: 6 }}>
            <table data-testid="juris-confirm-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f3ead2', position: 'sticky', top: 0 }}>
                  <th style={{ textAlign: 'left', padding: '6px 8px', borderBottom: '1px solid #e5d9b6' }}>Champ</th>
                  <th style={{ textAlign: 'left', padding: '6px 8px', borderBottom: '1px solid #e5d9b6' }}>Actuel (JurisÉvolution)</th>
                  <th style={{ textAlign: 'left', padding: '6px 8px', borderBottom: '1px solid #e5d9b6' }}>Nouvelle valeur</th>
                </tr>
              </thead>
              <tbody>
                {fields.map(f => {
                  const add = isAdd(f);
                  const bg = f.changed ? (add ? '#dcfce7' : '#fef3c7') : 'transparent';
                  return (
                    <tr key={f.key} data-testid={`juris-diff-row-${f.key}`}
                        data-action={add ? 'add' : 'overwrite'}
                        data-changed={f.changed ? '1' : '0'}
                        style={{ background: bg }}>
                      <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0e8d0', fontWeight: 600 }}>{f.label}</td>
                      <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0e8d0', color: '#6b7280' }}>
                        {f.current || '—'}
                        {f.changed && add && f.current
                          ? <span style={{ fontSize: 11, color: '#16a34a', display: 'block' }}>(conservé)</span>
                          : null}
                      </td>
                      <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0e8d0', fontWeight: f.changed ? 700 : 400 }}>
                        {f.changed && add
                          ? <span data-testid={`juris-add-badge-${f.key}`} style={{ background: '#16a34a', color: '#fff',
                              fontSize: 11, fontWeight: 700, borderRadius: 4, padding: '1px 6px', marginRight: 6 }}>＋ Ajout</span>
                          : null}
                        {f.new || '—'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          )}
          <p style={{ marginBottom: 0, fontWeight: 600 }}>Voulez-vous envoyer ces changements à JurisÉvolution ?</p>
        </div>
        <div className="popup-footer" style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button className="popup-btn" data-testid="juris-confirm-non" onClick={onCancel}
                  style={{ background: '#6b7280' }}>Non</button>
          <button className="popup-btn" data-testid="juris-confirm-oui" onClick={onConfirm}
                  style={{ background: '#d97706' }}>Oui, envoyer</button>
        </div>
      </div>
    </div>
  );
};

export default JurisConfirmModal;
